import { render, staticRenderFns } from "./MspTabellaRisultato.vue?vue&type=template&id=70cca778"
import script from "./MspTabellaRisultato.vue?vue&type=script&lang=js"
export * from "./MspTabellaRisultato.vue?vue&type=script&lang=js"
import style0 from "./MspTabellaRisultato.vue?vue&type=style&index=0&id=70cca778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports